import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {debounceTime} from "rxjs/operators";
import {Subject, Subscription} from "rxjs";
import {MatCheckboxChange} from "@angular/material/checkbox";
import {FormControl} from "@angular/forms";

@Component({
  selector: 'app-zones-select',
  templateUrl: './zones-select.component.html',
  styleUrls: ['./zones-select.component.scss']
})
export class ZonesSelectComponent implements OnInit, OnDestroy {
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    @Input() label?: string = 'COMMON.ZONES'
    @Input() zones: any[] = [];
    @Input() form: any;
    @Input() zonesControl: FormControl;
    @Output() dirtyEmitter: EventEmitter<boolean> = new EventEmitter(false);

    searchTermControl: FormControl = new FormControl();

    @ViewChild('searchTermInput') searchTermInput: ElementRef;

    zoneFormSubscriptions: Subscription;

    showMunicipality: boolean[][];
    showMunicipalitySavedState: boolean[][];
    showZones: boolean[] = [];
    savedZoneStateIndexs: boolean[] = [];
    updateSavedState:boolean = true;

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
        this.zoneFormSubscriptions.unsubscribe();
    }

    ngOnInit(): void {
        this.showMunicipality = this.zones.map(zone => {
            const municipalityArray = new Array(zone.municipalities?.length || 0).fill(false);
            zone.municipalities?.forEach((_, index) => {
                municipalityArray[index] = false;
            });
            return municipalityArray;
        });

        this.initMunicipalities(true);
        this.initZones(false);
        this.initSavedZoneStateIndexs();
        this.filterZonesObservable();
    }

    filterZonesObservable() {
        this.zoneFormSubscriptions = this.searchTermControl.valueChanges
            .pipe(debounceTime(400))
            .subscribe(value => {
                this.updateSavedState = true;
                this.initSavedZoneStateIndexs();
                if (!!value) {
                    this.zones?.forEach((zone, zoneIndex) => {
                        let hasMatchingMunicipality = true;
                        let hasMatchZone = true;
                        if (zone.name?.toLowerCase().includes(value.toLowerCase())) {
                            hasMatchZone = false
                            this.showZones[zoneIndex] = false;
                            this.hideShowAllZoneMunicipalities(zoneIndex, false);
                        } else {
                            this.showZones[zoneIndex] = true;
                            this.hideShowAllZoneMunicipalities(zoneIndex, true);
                        }
                        zone?.municipalities.forEach((municipality, municipalityIndex) => {
                            if (municipality.name?.toLowerCase().includes(value.toLowerCase())) {
                                hasMatchingMunicipality = false;
                                this.hideShowSpecificMunicipalitie(zoneIndex, municipalityIndex, false);
                            } else {
                                this.hideShowSpecificMunicipalitie(zoneIndex, municipalityIndex, true);
                            }
                        });
                        this.showZones[zoneIndex] = hasMatchingMunicipality && hasMatchZone;
                        if (!hasMatchZone) {
                            this.hideShowAllZoneMunicipalities(zoneIndex, false);
                        }
                    });
                } else {
                    this.initZones(false)
                    this.initMunicipalities(true);
                }
            });
    }


    initMunicipalities(initValue: boolean) {
        this.zones?.forEach((zone, zoneIndex) => {
            zone.municipalities?.forEach((municipality, municipalityIndex) => {
                this.showMunicipality[zoneIndex] [municipalityIndex]  = initValue;
            })
        });
    }

    initZones(initValue: boolean) {
        this.zones.forEach((zone, index) => {
            this.showZones[index] = initValue;
        });
    }

    initSavedZoneStateIndexs(){
        this.zones.forEach((zone, index) => {
            this.savedZoneStateIndexs[index] = true;
        });
    }

    compareZones(zone1: any, zone2: any): boolean {
        return zone1?.zone?.id === zone2?.zone?.id &&
            zone1?.municipality?.id === zone2?.municipality?.id;
    }

    toggleMunicipalities(index) {
        this.dirtyEmitter.emit(true);

        if ( this.searchTermControl?.value == '' || this.searchTermControl?.value == null) {
            this.showMunicipality[index] = this.showMunicipality[index].map(m => !m);
            this.updateSavedState = true;
        } else {
            if (this.updateSavedState) {
                this.showMunicipalitySavedState = [...this.showMunicipality];
                this.updateSavedState = false;
            }

            if (this.savedZoneStateIndexs[index]) {
                this.showMunicipalitySavedState[index] = [...this.showMunicipality[index]];
                this.savedZoneStateIndexs[index] = false;
                this.hideShowAllZoneMunicipalities(index, true);
            } else if (!this.savedZoneStateIndexs[index]) {
                this.showMunicipality[index] = [...this.showMunicipalitySavedState[index]];
                this.savedZoneStateIndexs[index] = true;
            }
        }
    }

    allMunicipalities(index: number): boolean{
        return this.showMunicipality[index].every(m => m);
    }

    allZonesVisible(): boolean{
        return this.showZones.every(m => m);
    }

    hideShowAllZoneMunicipalities(index: number, value: boolean) {
        this.showMunicipality[index] = this.showMunicipality[index].map(m => value);
    }

    hideShowSpecificMunicipalitie(zoneIndex: number, municipalityIndex: number, value: boolean) {
        this.showMunicipality[zoneIndex][municipalityIndex] = value;
    }

    openedChange(e) {
        this.searchTermControl.patchValue('');
        if (e == true) {
            this.searchTermInput.nativeElement.focus();
        }
    }

    selectProvince(event: MatCheckboxChange, zone: any) {
        let zonesList = this.zonesControl?.value || [];
        const municipalities = zone?.municipalities || [];
        const newZones = municipalities.map(municipalityId => ({
            zone: zone,
            municipality: municipalityId
        }));
        this.dirtyEmitter.emit(true);

        if (event.checked) {
            newZones.forEach(newZone => {
                if (!zonesList.some(zone => this.compareZones(zone, newZone))) {
                    zonesList.push(newZone);
                }
            });
        } else {
            zonesList = zonesList.filter(zone => !newZones.some(newZone => this.compareZones(zone, newZone)));
        }

        this.zonesControl?.setValue(zonesList);
    }

    removeProvince(zone: any) {
        let zonesList = this.zonesControl?.value || [];
        const municipalities = zone?.municipalities || [];
        this.dirtyEmitter.emit(true);
        const newZones = municipalities.map(municipalityId => ({
            zone: zone,
            municipality: municipalityId
        }));
        zonesList = zonesList.filter(zone => !newZones.some(newZone => this.compareZones(zone, newZone)));
        this.zonesControl?.setValue(zonesList);
    }

    allMunicipalitiesChecked(params: { index?: number, zone?: any }): boolean {
        const {index, zone} = params;

        let zonesList = this.zonesControl?.value || [];

        const municipalities = !!zone ? zone?.municipalities || [] : this.zones[index]?.municipalities || [];

        const newZones = municipalities.map(municipalityId => ({
            zone: !!zone ? zone : this.zones[index],
            municipality: municipalityId
        }));

        return newZones.every(newZone =>
            zonesList.some(zone => this.compareZones(zone, newZone))
        );
    }

    clearSearch(event){
        event.stopPropagation();
        this.searchTermControl.patchValue('');
    }

    remove(element: any)  {
        const currentValues = this.zonesControl?.value || [];
        this.dirtyEmitter.emit(true);

        const index = currentValues.indexOf(element);

        if (index >= 0) {
            const updatedValues = [...currentValues];
            updatedValues.splice(index, 1);

            this.zonesControl?.setValue(updatedValues);
            this.zonesControl?.markAsDirty();
            this.zonesControl?.markAsTouched();
        }
    }

    updateFormState() {

    }
}
